import React, { useEffect, useState } from 'react';
import cx from './index.module.scss';
import { Card, ConfirmModal, Loader } from 'src/components/common';
import { bookmarkicon, emptyideabulb, redirectlinkicon } from 'src/assets/images';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useGetIdentity } from 'src/hooks';
import { clearMyIdeas, getMyIdeas, incrementMyIdeasPage, resetMyIdeasSharedPage } from 'src/store/ideaHub/ideaHub.slice';
import { TMyIdeasRequest } from 'src/services/apiEndpoint.types.ts';
import { TIdea } from 'src/components/ideaHub/ideaHub.types';
import { formatDate, textEllipsis } from 'src/utils';
import { useNavigate } from 'react-router-dom';

export default function MyIdeaListCard({ isView = false }: { isView?: boolean }) {
  const dispatch = useAppDispatch();
  const navigate: any = useNavigate()
  const isAuthorized: boolean = useAppSelector<boolean>((store: any) => store.auth.isAuthorized);
  const { getIdentities } = useGetIdentity();
  const {
    myIdeasPageNumber,
    myIdeas,
    myIdeasItemsPerPage,
    myIdeasMoreItemsLeft,
    ideasFeedLoading
  } = useAppSelector((store) => store.ideaHub);
  const { authenticatedId } = getIdentities();
  const [show, setShow] = useState<boolean>(false);

  const fetchIdeas = ({ resetPreviousData }: { resetPreviousData: boolean }) => {
    if (!authenticatedId) return
    if (resetPreviousData) {
      dispatch(resetMyIdeasSharedPage());
    }
    const payload: TMyIdeasRequest = {
      userId: authenticatedId,
      orderBy: 'latest',
      offset: resetPreviousData ? 1 : myIdeasPageNumber,
      limit: myIdeasItemsPerPage || 10
    };
    dispatch(getMyIdeas(payload));
  };

  const loadMoreItems = () => {
    if (myIdeasMoreItemsLeft && !ideasFeedLoading && myIdeas?.length > 0) {
      dispatch(incrementMyIdeasPage(1));
    }
  };

  function handleNavigate(ideaId: string) {
    navigate(`/idea-detail?id=${ideaId}`)
  }
  function handleCreateIdea() {
    if (!isAuthorized) {
      setShow(true);
      return
    }
    navigate('/idea-hub')
  }
  const handleNavigateToLogin: any = () => {
    navigate('/login?prev=/discover')
  }

  useEffect(() => {
    if (!authenticatedId) return;

    dispatch(resetMyIdeasSharedPage());

    const payload: TMyIdeasRequest = {
      userId: authenticatedId,
      orderBy: 'latest',
      offset: 1,
      limit: myIdeasItemsPerPage || 10
    };
    dispatch(getMyIdeas(payload));
    // return () => {
    //   dispatch(clearMyIdeas());
    // };
  }, [authenticatedId])

  useEffect(() => {
    if (myIdeasPageNumber > 1 && authenticatedId && !ideasFeedLoading) {
      fetchIdeas({ resetPreviousData: false });
    }
  }, [myIdeasPageNumber, authenticatedId]);

  return (
    <>
      <ConfirmModal
        title=""
        description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
          <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
          <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
        </p>}
        openConfirmModal={show}
        onClose={() => setShow(false)}
        onSubmit={handleNavigateToLogin}
        submitText="Sign in"
        type="confirm"
      />
      <Card>
        <div className={cx.container}>
          {/* Header */}
          <div className={cx.header}>
            <img src={bookmarkicon} alt="bookmark-icon" />
            <h2 className={cx.title}>Saved ideas</h2>
          </div>

          {/* Ideas List */}
          <div className={cx.ideasList}>
            {myIdeas.map((idea: TIdea | any) => {
              return (
                <div
                  key={idea?.idea?.id}
                  className={`${cx.ideaItem}`}
                  onClick={() => handleNavigate(idea?.idea?.id)}
                >
                  <div className={cx.ideaContent}>
                    <h3 className={cx.ideaTitle}>{textEllipsis({ charLimit: 30, text: idea?.idea?.title }).text}</h3>
                    <p className={cx.timestamp}>{formatDate({ dateString: idea?.idea?.createdAt })}</p>
                  </div>

                  <img src={redirectlinkicon} alt="redirect-icon" />
                </div>
              )
            })}
            {myIdeas?.length === 0 && !ideasFeedLoading && (
              <div className={cx.emptyIdeaCard}>
                <img src={emptyideabulb} alt="emptyideabulb" />
                <h5>No ideas yet </h5>
                <p>but the <strong>next unicorn</strong> might be one click away.</p>
                {isView && <button onClick={handleCreateIdea}>Try generating an idea now.</button>}
              </div>
            )}
            {!ideasFeedLoading && myIdeasMoreItemsLeft && <div className={cx.loadmorecontainer}>
              <span className={cx.loadmoretext} onClick={loadMoreItems}>load more</span>
            </div>}
            {ideasFeedLoading && <Loader />}
          </div>
        </div>
      </Card>
    </>
  );
}
